import React, { useEffect, useState } from 'react';
import { createSelector } from 'reselect';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Form, Row, Col, Input, DatePicker, Table,Select,theme,Modal,Image,Card,Empty } from 'antd';

import usecustomStyles from '../Common/customStyles';
import * as PoleThunk from '../slices/poles/thunk';
import Spinners from '../Common/Spinner';

const customStyles = usecustomStyles();
const { RangePicker } = DatePicker;

function DataList() {
    const BaseTableColumns = [
        {
            title: '项目名称',
            dataIndex: 'project_name',
            sorter: (a, b) => a.projectName.localeCompare(b.projectName),
            sortDirections: ['ascend', 'descend'],
            align:'center',
            width: 100,
        },
        {
            title: '工区名称',
            dataIndex: 'site_name',
            sorter: (a, b) => a.siteName.localeCompare(b.siteName),
            sortDirections: ['ascend', 'descend'],
            align:'center',
            width: 100,
        },
        {
            title: '位置',
            dataIndex: 'position',
            align:'center',
            width: 80,
        },
        {
            title: '时间',
            dataIndex: 'time',
            sorter: (a, b) => a.time.localeCompare(b.time),
            sortDirections: ['ascend', 'descend'],
            render: item => (
                <React.Fragment>
                    <span>{moment(item).format('YYYY-MM-DD HH:mm:ss')}</span>
                </React.Fragment>
            ),
            align:'center',
            width: 100,
        },
        {
            title: '详情',
            dataIndex: 'data',
            align:'center',
            width: 180,
        },
        {
            title: '图片',
            dataIndex: 'picture_url',
            render: item => (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                item ? <a onClick={() => handleImageClick(item)} style={{ cursor: 'pointer' }}>查看</a> : ''
            ),
            align:'center',
            width: 60,
        },
    ];
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const selector = createSelector(
        state => state.Poles,
        state => ({
            alarmLogList: state.alarmLogList,
            loading: state.loading,
        }),
    );
    const dispatch = useDispatch();

    const { alarmLogList, loading } = useSelector(selector);

    /**
     * 当前数据列表"加载中"状态
     */
    const [isLoading, setLoading] = useState(loading);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);

    useEffect(() => {
        dispatch(PoleThunk.getAlarmLogs());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const pagination = {
        pageSizeOptions: ['5', '10', '20', '50'], // 页条数下拉选择器的选项
        defaultPageSize: 10, // 默认的页大小
        showSizeChanger: true, // 显示页大小改变器
    };
    
    const handleImageClick = (imageUrl) => {
        setCurrentImage(imageUrl);
        setIsModalVisible(true);
    };

    const handleModalCancel = () => {
        setIsModalVisible(false);
        setCurrentImage(null);
    };

    const onFinish = (values) => {
        let params = {};

        if (values.project_name) {
            params.projectName = values.project_name;
        }

        if (values.timeRange && values.timeRange.length === 2) {
            const [startTime, endTime] = values.timeRange;
            params.startTime = new Date(startTime).toISOString();
            params.endTime = new Date(endTime).toISOString();
        }

        // 只有在参数存在时才传递
        if (Object.keys(params).length > 0) {
            dispatch(PoleThunk.getAlarmLogs(params));
        } else {
            dispatch(PoleThunk.getAlarmLogs());
        }
    };

    return(
        <React.Fragment>
            <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                <Card style={{ marginTop: customStyles.margin, marginBottom: customStyles.margin }} className="ApiTable">
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: customStyles.margin }}>
                        <h4 style={{ fontSize: '16px', fontWeight: '500' }}>预警记录</h4>
                    </div>
                    <Form
                        form={form}
                        name="alarms_search"
                        // className="ant-advanced-search-form"
                        onFinish={onFinish}
                        >
                        <Row gutter={24} style={{ margin: '18px 0',color: token.colorText }}>
                            <Col span={6}>
                                <Form.Item name="project_name" label="项目名称">
                                    <Input name="project_name" type="text" />
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item name="disposeSituation" label="处置情况">
                                    <Select name="disposeSituation" />
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item name="timeRange" label="时间范围">
                                    <RangePicker name="timeRange" />
                                </Form.Item>
                            </Col>
                            <Col
                                span={6}
                                style={{
                                    textAlign: 'right',
                                }}
                            >
                                <Button type="primary" htmlType="submit">
                                    查询
                                </Button>
                                <Button
                                    style={{
                                    margin: '0 8px',
                                    }}
                                    onClick={() => {
                                    form.resetFields();
                                    }}
                                >
                                    重置
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                    {isLoading ? (
                        <Spinners setLoading={setLoading} />
                    ) : (
                        <React.Fragment>
                            {alarmLogList && alarmLogList.length > 0 ? (
                                <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                                    <Table className='table-list' rowKey="id" columns={BaseTableColumns} dataSource={alarmLogList} pagination={pagination} scroll={{y:'calc(100vh - 408px)'}}/>
                                </div>
                            ) : (
                                <Empty image="/nodata.png" description={<span></span>} style={{ padding: '10%' }}></Empty>
                            )}
                        </React.Fragment>
                    )}
                </Card>
                <Modal
                    visible={isModalVisible}
                    title="图片"
                    onCancel={handleModalCancel}
                    footer={null}
                >
                    {currentImage && <Image src={currentImage} alt="查看图片" preview={false} width= '100%'/>}
                </Modal>
            </div>
        </React.Fragment>
    );
};

export default DataList;
